import { FC, useContext } from 'react';
import clsx from 'clsx';

import { RichText } from '@marriott/mi-ui-library';

import { PageContext } from '../../../modules/context/PageContext';
import { StyledWalletSectionUxlError } from './WalletSectionUxlError.styles';

type WalletSectionUxlErrorProps = {
  className?: string;
};

/**
 * Section-level UXL failure banner for wallet widgets.
 * Uses inline message markup (not the Messages atom) to avoid extra container/row padding.
 * Padding and text weight match wallet Figma (o-inline-message).
 */
export const WalletSectionUxlError: FC<WalletSectionUxlErrorProps> = ({ className }) => {
  const pageContext = useContext(PageContext);

  return (
    <StyledWalletSectionUxlError
      className={clsx('wallet-section-uxl-error', className)}
      data-testid="wallet-section-uxl-error"
    >
      <div className="m-message-inline warning p-3 p-md-4">
        <div className="m-message-content-wrap">
          <div className="m-message-content">
            <RichText text={pageContext?.uxlErrorMessage} componentId="uxl-error-msg" />
          </div>
        </div>
      </div>
    </StyledWalletSectionUxlError>
  );
};
